<template>
  <van-cell-group id="form_cell_group">
    <h3 class="cell_title">实名信息</h3>
    <van-field
      key="legalCardUpImg"
      name="sfz_up"
      label="身份证头像面"
      :rules="[{ validator: uploadValidator, message: '请上传身份证头像面' }]"
    >
      <template #input>
        <CellUpload
          enums="ID_CARD"
          text="身份证头像面"
          type="0001"
          v-model="realNameFormObj.sfz_up"
          name="法人身份证"
          @change="uploadChange"
        />
      </template>
    </van-field>
    <van-field
      key="legalCardDownImg"
      name="sfz_down"
      label="身份证国徽面"
      :rules="[{ validator: uploadValidator, message: '请上传身份证国徽面' }]"
    >
      <template #input>
        <CellUpload
          enums="ID_CARD"
          text="身份证国徽面"
          type="0011"
          v-model="realNameFormObj.sfz_down"
          name="身份证反面"
          @change="uploadChange"
        />
      </template>
    </van-field>
    <van-field
      key="legalName"
      name="legal_name"
      v-model="realNameFormObj.legal_name"
      label="法人姓名"
      placeholder="请输入"
      :rules="[{ required: true, message: '请输入法人姓名' }]"
    />
    <van-field
      v-if="reg_mer_type === '02'"
      key="legalSex"
      name="legal_sex"
      label="法人性别"
      :value="realNameFormObj.legal_sex"
      :rules="[{ required: true, message: '请选择法人性别' }]"
    >
      <template #input>
        <select-popup
          v-model="realNameFormObj.legal_sex"
          :columns="[
            { text: '男', value: '1' },
            { text: '女', value: '2' },
          ]"
        />
      </template>
    </van-field>
    <van-field
      key="legalOccupation"
      v-if="reg_mer_type === '02'"
      style="display: none"
      name="legal_occupation"
      label="法人职业"
      :value="realNameFormObj.legal_occupation"
      :rules="[{ required: true, message: '请选择商户类型' }]"
    >
      <template #input>
        <select-popup
          v-model="realNameFormObj.legal_occupation"
          :columns="occupationColumns"
        />
      </template>
    </van-field>
    <van-field
      v-if="reg_mer_type === '02' && realNameFormObj.legal_occupation === '7'"
      key="legalCareerDesc"
      name="legalmanCareerDesc"
      v-model="realNameFormObj.legalmanCareerDesc"
      label="职业详细描述"
      placeholder="请输入"
      :rules="[{ required: true, message: '请输入法人职业详细描述' }]"
    />
    <van-field
      key="legalMobile"
      name="legal_mobile"
      v-model="realNameFormObj.legal_mobile"
      label="法人手机号"
      placeholder="请输入"
      :rules="[
        { required: true, message: '请输入法人手机号' },
        {
          pattern: /^1[3456789]\d{9}$/,
          message: '法人手机号格式错误',
          trigger: 'onBlur',
        },
      ]"
    />
    <van-field
      key="legalEmail"
      name="legal_email"
      v-model="realNameFormObj.legal_email"
      label="邮箱"
      placeholder="请输入"
      :rules="[
        { required: true, message: '请输入邮箱' },
        {
          pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: '邮箱格式错误',
          trigger: 'onBlur',
        },
      ]"
    />
    <van-field
      key="legalCardNo"
      name="legal_idcard_no"
      v-model="realNameFormObj.legal_idcard_no"
      label="身份证号码"
      placeholder="请输入"
      :rules="[
        { required: true, message: '请输入身份证' },
        {
          pattern:
            /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|[xX])$/i,
          message: '身份证号格式错误',
          trigger: 'onBlur',
        },
      ]"
    />
    <van-field
      key="legalCardBegin"
      name="legalCardBeginDate"
      label="身份证开始日期"
      :value="realNameFormObj.legalCardBeginDate"
      :rules="[{ required: true, message: '请选择身份证开始日期' }]"
    >
      <template #input>
        <van-cell
          class="date_cell"
          is-link
          @click="beginDatePickerShow = true"
          :value="realNameFormObj.legalCardBeginDate"
        />
      </template>
    </van-field>
    <van-popup v-model="beginDatePickerShow" position="bottom" round>
      <van-datetime-picker
        type="date"
        :value="realNameFormObj.legalCardBeginDate"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="beginDateConfirm"
        @cancel="beginDatePickerShow = false"
      />
    </van-popup>
    <van-field
      key="legalCardEnd"
      name="legal_card_deadline"
      label="身份证截止日期"
      :value="realNameFormObj.legal_card_deadline"
      :rules="[{ required: true, message: '请选择身份证截止日期' }]"
    >
      <template #input>
        <van-cell
          class="date_cell"
          is-link
          @click="openEndDate"
          :value="legal_card_deadline_text"
        />
      </template>
    </van-field>
    <van-popup v-model="endDatePickerShow" position="bottom" round>
      <van-datetime-picker
        type="date"
        :value="realNameFormObj.legal_card_deadline"
        :min-date="minDate1"
        :max-date="maxDate1"
        :readonly="is_valid"
        @confirm="endDateConfirm"
        @cancel="endDatePickerShow = false"
      />
      <van-checkbox
        class="date_popup_check"
        v-model="is_valid"
        shape="square"
        icon-size="14px"
      >
        长期有效
      </van-checkbox>
    </van-popup>
    <van-field
      v-if="reg_mer_type !== '' && reg_mer_type !== '00'"
      key="legalCardHandImg"
      name="sfz_hand"
      label="手持身份证图片"
      :rules="[{ validator: uploadValidator, message: '请上传手持身份证图片' }]"
    >
      <template #input>
        <CellUpload
          text="手持身份证图片"
          type="0007"
          v-model="realNameFormObj.sfz_hand"
          name="自拍照（手持身份证）"
        />
      </template>
    </van-field>
  </van-cell-group>
</template>

<script>
import SelectPopup from "./SelectPopup";
import CellUpload from "./CellUpload";
export default {
  components: {
    SelectPopup,
    CellUpload,
  },
  props: ["reg_mer_type", "formObj", "changePictureItem", "partnerInfo"],
  data() {
    return {
      realNameFormObj: {
        legal_name: "",
        legal_sex: "",
        legal_occupation: "3",
        legalmanCareerDesc: "",
        legal_mobile: "",
        legal_email: "",
        legal_idcard_no: "",
        legalCardBeginDate: "",
        legal_card_deadline: "",
        sfz_up: {
          document_name: "法人身份证",
          document_type: "0001",
          file_path: "",
        },
        sfz_down: {
          document_name: "身份证反面",
          document_type: "0011",
        },
        sfz_hand: {
          document_name: "自拍照（手持身份证）",
          document_type: "0007",
        },
      },
      beginDatePickerShow: false,
      endDatePickerShow: false,
      minDate: new Date(1970, 1, 1),
      minDate1: new Date(1970, 1, 1),
      maxDate: new Date(new Date().getFullYear() + 30, 11, 31),
      maxDate1: new Date(new Date().getFullYear() + 30, 11, 31),
      is_valid: false,
      occupationColumns: [
        { text: "各类专业、技术人员", value: "0" },
        { text: "国家机关、党群组织、企事业单位的负责人", value: "1" },
        { text: "办事人员和有关人员", value: "2" },
        { text: "商业工作人员", value: "3" },
        { text: "服务性工作人员", value: "4" },
        { text: "农林牧渔劳动者", value: "5" },
        { text: "生产工作、运输工作和部分体力劳动者", value: "6" },
        { text: "不便分类的其他劳动者", value: "7" },
      ],
    };
  },
  created() {
    this.maxDate = new Date(new Date().getFullYear() + 30, 11, 31);
  },
  watch: {
    formObj: {
      handler(newV, oldV) {
        for (const key in this.realNameFormObj) {
          if (this.realNameFormObj[key] instanceof Object) {
            let pictureItem = newV.picture.filter(
              (item) => item.type === this.realNameFormObj[key].document_type
            );
            if (pictureItem[0]) {
              this.realNameFormObj[key] = {
                ...this.realNameFormObj[key],
                file_path: pictureItem[0].tripartitePath,
                file_size: pictureItem[0].pictureSize,
                url: pictureItem[0].fastPath,
              };
            }
          } else if (
            Object.hasOwnProperty.call(newV.commitData.complexUploadBasic, key)
          ) {
            if (key === "legal_card_deadline")
              this.is_valid =
                newV.commitData.complexUploadBasic[key] === "9999-12-31";
            this.realNameFormObj[key] = newV.commitData.complexUploadBasic[key];
          }
        }
      },
      deep: true,
    },
    changePictureItem: {
      handler(newV, oldV) {
        switch (newV.document_type) {
          case "0001":
            this.realNameFormObj.sfz_up = newV;
            break;
          case "0011":
            this.realNameFormObj.sfz_down = newV;
            break;
        }
      },
      deep: true,
    },
    partnerInfo: {
      handler(newV, oldV) {
        this.realNameFormObj = {
          ...this.realNameFormObj,
          ...newV,
        };
      },
      deep: true,
    },
  },
  computed: {
    legal_card_deadline_text() {
      return this.realNameFormObj.legal_card_deadline === "9999-12-31"
        ? "长期有效"
        : this.realNameFormObj.legal_card_deadline;
    },
  },
  methods: {
    openEndDate() {
      this.endDatePickerShow = true;
      this.minDate1 = new Date(this.realNameFormObj.legalCardBeginDate);
      this.maxDate1 = new Date(
        new Date(this.realNameFormObj.legalCardBeginDate).getFullYear() + 30,
        11,
        31
      );
    },
    uploadValidator(value, rule) {
      return value[0].file_path && value[0].file_path !== "" ? true : false;
    },
    uploadChange(query) {
      if (query.document_type == "0001") {
        this.realNameFormObj.legal_name = query.name;
        this.realNameFormObj.legal_idcard_no = query.idNumber;
      } else if (query.document_type == "0011") {
        let legalCardDate = query.validPeriod.split("-");
        let legalCardBeginDate = legalCardDate[0];
        let legal_card_deadline =
          legalCardDate[1] === "长期" ? "9999-12-31" : legalCardDate[1];
        this.realNameFormObj.legalCardBeginDate = this.$global.transferDay(
          new Date(legalCardBeginDate)
        );
        this.realNameFormObj.legal_card_deadline = this.$global.transferDay(
          new Date(legal_card_deadline)
        );
      }
      query.closeLoding();
    },
    beginDateConfirm(query) {
      this.realNameFormObj.legalCardBeginDate = this.$global.transferDay(query);
      this.beginDatePickerShow = false;
    },
    endDateConfirm(query) {
      this.realNameFormObj.legal_card_deadline = this.is_valid
        ? "9999-12-31"
        : this.$global.transferDay(query);
      this.endDatePickerShow = false;
    },
  },
};
</script>

<style scoped lang="scss">
#form_cell_group {
  margin-top: 24px;

  .cell_title {
    font-size: 15px;
    color: #333333;
    line-height: 21px;
    margin: 13px 0 3px;
  }

  .date_cell {
    padding: 0;
    border: none;

    &::v-deep .van-cell__value {
      text-align: right;
    }
  }

  .date_popup_check {
    margin: 22px 0;
    justify-content: center;
  }
}
</style>
